import { render, staticRenderFns } from "./BulkProductGridTabs.vue?vue&type=template&id=d198e750&"
import script from "./BulkProductGridTabs.vue?vue&type=script&lang=js&"
export * from "./BulkProductGridTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports